(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/hooks/use-local-storage.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/hooks/use-local-storage.js');
"use strict";


const {
  useCallback,
  useState
} = React;
const useLocalStorage = function (key, domain) {
  var _svs$components$Stora;
  let initialValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let expirationTimeMinutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const [storedValue, setStoredValue] = useState(((_svs$components$Stora = svs.components.Storage) === null || _svs$components$Stora === void 0 ? void 0 : _svs$components$Stora.browser.get(key, domain)) || initialValue);
  const setValue = useCallback(value => {
    setStoredValue(storedValue => {
      var _svs$components$Stora2;
      const valueToStore = typeof value === 'function' ? value(storedValue) : value;
      (_svs$components$Stora2 = svs.components.Storage) === null || _svs$components$Stora2 === void 0 || _svs$components$Stora2.browser.set(key, domain, valueToStore, expirationTimeMinutes);
      return valueToStore;
    });
  }, [key, domain, expirationTimeMinutes]);
  const clearValue = useCallback(() => {
    var _svs$components$Stora3;
    (_svs$components$Stora3 = svs.components.Storage) === null || _svs$components$Stora3 === void 0 || _svs$components$Stora3.browser.remove(key, domain);
    setStoredValue(initialValue);
  }, [key, domain, initialValue]);
  return [storedValue, setValue, clearValue];
};
setGlobal('svs.ticketsValidateManual.hooks.useLocalStorage', useLocalStorage);

 })(window);